import { IonCol, IonContent, IonGrid, IonInput, IonPage, IonRow, IonText, IonIcon, IonSpinner } from "@ionic/react"
import moment from "moment"
import { useEffect, useState, useMemo } from "react"
import { useHistory, useLocation } from "react-router"
import { Modal } from "react-bootstrap"
import DataTable from "react-data-table-component"
import Select from 'react-select';
import service from "../../../Service/service"
import Head from "../../Header"
import Sidebar from "../../Sidebar"
import swal from 'sweetalert'
import { searchOutline, chevronDownOutline, create } from "ionicons/icons";
import ActivityCreateProject from "../../Team Member/ActivityCreateProject"

const HRProjectDashboard: React.FC = () => {
    const history = useHistory();
    const location: any = useLocation()
    const [token] = useState(localStorage.getItem("SignupEmpId"));

    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {
            if (location.state) {
                console.log(location)
                setId(location.state.projectId)

            }

        }
    }, [token, history]);
    const [data, setData]: any = useState([]);
    const [data1, setdata1]: any = useState([]);

    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [business, setBusiness] = useState("");

    const [modalopen, setModalopen] = useState(false);

    const [id, setId] = useState("");

    const [clientView, setClientView] = useState([]);

    const [createdBy]: any = useState(localStorage.getItem("SignupEmpId"));
    const [updatedBy] = useState(localStorage.getItem("SignupEmpId"));

    const [statusList, setStatusList] = useState([]);
    const [isEdit, setIsEdit] = useState(true);
    const [statusId, setStatusId] = useState('');
    const [loading, setloading] = useState(false)
    /*........Create.......... */

    const [bussinessUnit, setBussinessUnit] = useState("");
    const [departmentUnit, setDepartmentUnit] = useState("");

    /*......... VIew & Update .......... */
    const [pname, setPname] = useState("");
    const [cname, setCname] = useState("");
    const [fDate, setFDate] = useState("");
    const [tDate, setTDate] = useState("");
    const [total, setTotal] = useState("");
    const [desc, setDeasc] = useState("");
    const [prjstatus, setprjstatus] = useState("Open");
    const [assignedResources, setAssignedResources] = useState([]);
    const [updateBussinessUnit, setUpdateBussinessUnit] = useState("");
    const [updateDepartmentUnit, setUpdateDepartmentUnit] = useState("");
    const [projectManager, setProjectManager] = useState("");
    const [projectDescription, setProjectDescription] = useState("");
    const [projectStatusId, setProjectStatusId] = useState("")
    const [assign]: any = useState(localStorage.getItem("SignupEmpId"));
    const [TillDate, settilldate] = useState("")
    const [TillMonth, settillmonth] = useState('')



    //.................Project Status Autocomplete........................//

    const [selectedOption9, setSelectedOption9] = useState(null);
    const [inputValue9, setInputValue9] = useState('');
    const [isFocused9, setIsFocused9] = useState(false);
    const [menuIsOpen9, setMenuIsOpen9] = useState(false);

    const handleStateChange9 = (selectedOption9: any) => {
        setSelectedOption9(selectedOption9);
    };

    const handleInputChange9 = (inputValue9: any) => {
        setInputValue9(inputValue9);
    };

    const handleMenuOpen9 = () => {
        setMenuIsOpen9(true);
    };

    const handleMenuClose9 = () => {
        setMenuIsOpen9(false);
    };

    const handleFocus9 = () => {
        setIsFocused9(true);
    };

    const handleBlur9 = () => {
        setIsFocused9(false);
    };

    const Placeholder9 = () => {
        if (inputValue9 === '' && !selectedOption9 && !isFocused9) {
            return <span style={{ color: "black" }}>Open</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator9: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen9) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen9]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const options9 = statusList.map((state: any) => ({
        value: state.id,
        label: state.status,
    }));

    const hanldeStatusTypes = (selectedOption9: any) => {
        setProjectStatusId(selectedOption9.value)
    }





    //----------------Getall Projects Datatable---------------// 

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: true,
            width: "83px",
        },
        {
            name: "Business Unit",
            selector: (itm: any) => itm.businessUnit.businessUnitName,
            cell: (itm: any) => {
                if (itm.businessUnit && itm.businessUnit.businessUnitName !== null && itm.businessUnit.businessUnitName !== undefined) {
                    return itm.businessUnit.businessUnitName;
                } else {
                    return 'NA';
                }
            },

            sortable: true,
            sort: "businessUnitName",
            width: "150px"
        },
        {
            name: "Department",
            selector: (itm: any) => {
                if (itm.masterDepartment && itm.masterDepartment.departmentName !== null && itm.masterDepartment.departmentName !== undefined) {
                    return itm.masterDepartment.departmentName;
                } else {
                    return 'NA';
                }
            },
            sortable: true,
            sort: "departmentName",
            width: "150px"
        },
        {
            name: "Project Name",
            selector: (itm: any) => itm.projectName,
            sortable: true,
            width: "200px"
        },
        {
            name: "Created Date",
            selector: (itm: any) => itm.createdDate,
            sortable: true,
            sort: "createdDate",
            cell: (itm: any) => {
                var crDate = moment(itm.createdDate).format("DD-MM-YYYY")
                return (
                    <>
                        <IonText>{crDate}</IonText>
                    </>
                )
            },
            width: "145px"
        },
        {
            name: "Created By",
            selector: (itm: any) => itm.createdBy,
            sortable: true,
            width: "150px"

        },
        {
            name: "Resources",
            selector: (itm: any) => itm.noOfResources,
            sortable: true,
            width: "121px"
        },
        {
            name: "Status",
            // selector: (itm: any) => itm.projectStatus.status,
            sortable: true,
            width: "94px",
            cell: (itm: any) => (
                <div style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    {itm.projectStatus.status === "Open" ? (
                        <p style={{ color: "#00b700", margin: '0' }}>Open</p>
                    ) : itm.projectStatus.status === "Hold" ? (
                        <p style={{ color: "orange", margin: '0' }}>Hold</p>
                    ) : (
                        <p style={{ color: "red", margin: '0' }}>Close</p>
                    )}
                </div>

            )
        },
        {
            name: "View",
            sortable: false,
            // width: "100px",
            cell: (itm: any) => (
                <div>
                    <IonText onClick={() => openmodal(itm.id)} style={{ color: "coral", cursor: 'pointer', fontSize: '14px', padding: "2px" }}>View</IonText>
                </div>
            )

        },

    ];

    // ----------------Modal datatable--------------

    const ViewProject: any = [
        {
            name: "Activity",
            selector: (itm: any, i: any) => itm.activity,
            width: '250px',

            sortable: true,

        },
        {
            name: "YTD Effort",
            selector: (itm: any) => itm.effortTillDate,

            // cell: (itm: any) => {
            //     if (itm.businessUnit && itm.businessUnit.businessUnitName !== null && itm.businessUnit.businessUnitName !== undefined) {
            //         return itm.businessUnit.businessUnitName;
            //     } else {
            //         return 'NA';
            //     }
            // },

            sortable: true,
            // sort: "businessUnitName",
            // width: "150px"
        },
        {
            name: "Current Month",
            selector: (itm: any) => itm.effortThisMonth,
            // selector: (itm: any) => {
            //     if (itm.masterDepartment && itm.masterDepartment.departmentName !== null && itm.masterDepartment.departmentName !== undefined) {
            //         return itm.masterDepartment.departmentName;
            //     } else {
            //         return 'NA';
            //     }
            // },
            sortable: true,
            // sort: "departmentName",
        },


    ];
    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };
    //---------------Search filter---------------//

    const tabledata = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );
    const datas = data1.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);
    // const customSubHeader = (
    //     <div>

    //     </div>
    // );
    //---------------Getall Api------------------//    

    useEffect(() => {
        var role = localStorage.getItem("UserRole")
        console.log(role, "kmk")
        if (role === "MANAGER" || role === "Manager") {
            setIsEdit(false)
        }
        else {
            setIsEdit(true)
        }

        LoadProject();
        console.log("getstatuslist", GetStatusList)
        GetStatusList();
    }, [])


    const LoadProject = () => {
        setloading(true);
        service.GetallProject(createdBy, projectStatusId)
            .then((response) => {
                console.log(response);
                if (response.data.status === "400") {
                    setData([]);
                } else {
                    setData(response.data.Data);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                
                setTimeout(() => {
                    setloading(false); 
                }, 500);
            });
    };


    // ----------------------Get status list ---------------------

    const GetStatusList = () => {
        service.GetPrjClsStatuslist()
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    setStatusList(response.data);
                }
                else {
                    setStatusList([])
                }
            })
    }
    //--------------Clients Dropdown Api-----------------//

    const openmodal = (id: any) => {
        setId(id);
        setModalopen(true);
        setloading(true);
        service.GetHistoryProjectById(id)
            .then((response) => {
                if (response.status === 200) {
                    setdata1(response.data.report);
                    console.log(response);
                    // -------Project Name -----
                    if (response.data.project.projectName === null || response.data.project.projectName === "") {
                        setPname("");
                    } else {
                        setPname(response.data.project.projectName);
                        // fromDate
                    }
                    if (response.data.project.fromDate === null || response.data.project.fromDate === "") {
                        setCname("");
                    } else {
                        setCname(response.data.project.fromDate);
                    }
                    // -------  From Date  -----
                    if (response.data.project.fromDate === null || response.data.project.fromDate === "") {
                        setFDate("");
                    } else {
                        setFDate(response.data.project.fromDate);
                    }
                    // -------To Date-----
                    if (response.data.project.toDate === null || response.data.project.toDate === "") {
                        setTDate("");
                    } else {
                        setTDate(response.data.project.toDate);
                    }
                    // -------Project Description-----
                    if (response.data.project.project_Description === null || response.data.project.project_Description === "") {
                        setProjectDescription("");
                    } else {
                        setProjectDescription(response.data.project.project_Description);
                    }
                    // -------Project manager-----
                    if (response.data.project.projectManager === null || response.data.project.projectManager === "") {
                        setProjectManager("");
                    } else {
                        setProjectManager(response.data.project.projectManager);
                    }
                    // ------Assigned Resource-----
                    if (response.data.project.assignedResources === null || response.data.project.assignedResources === "") {
                        setAssignedResources([]);
                    } else {
                        setAssignedResources(response.data.project.assignedResources);
                    }
                    settilldate(response.data.effortTill);
                    settillmonth(response.data.effortMonth);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {

                setTimeout(() => {
                    setloading(false);
                }, 2000);
            });
    };
    const closemodal = () => {

        setModalopen(false);
        setCname("");
        setPname("");
        setFDate("");
        setTDate("");
        setDeasc("");
        setUpdateBussinessUnit("");
        setUpdateDepartmentUnit("");
        setProjectManager("");
        setAssignedResources([]);
    }
    const back = () => {
        history.goBack();
    }
    const hanldeStatusType = (e: any) => {
        setProjectStatusId(e.target.value)
    }

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <h3 className="page-title"> <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "2px" }} /> Dashboard </h3>
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item active">My Project & Status</li>
                                    </ul>
                                </div>

                            </div>
                            <div className="row filter-row" style={{ marginTop: "3%" }}>
                                <div className="col-sm-6 col-md-3">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Project Status</label>
                                        <Select
                                            options={options9}

                                            value={options9.find((option: any) => option.value === projectStatusId) || null}
                                            onChange={hanldeStatusTypes}
                                            onInputChange={handleInputChange9}
                                            onMenuOpen={handleMenuOpen9}
                                            onMenuClose={handleMenuClose9}
                                            onFocus={handleFocus9}
                                            onBlur={handleBlur9}
                                            menuIsOpen={menuIsOpen9}
                                            isSearchable
                                            // disabled={isEdit === true ? false : true}
                                            placeholder={<Placeholder9 />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator9,
                                            }}
                                            className="custom-select0"
                                        />
                                    </div>

                                </div>
                                <div className="col-sm-6 col-md-3" style={{ display: "flex", alignSelf: "center", justifySelf: "center" }}>
                                    <a onClick={() => {
                                        // Empresources();
                                        LoadProject();
                                    }} className="btn btn-orange btn-block w-100"> Submit </a>
                                </div>
                            </div>
                            {loading && (
                            <div
                                style={{
                                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                }}
                            >
                                <div>
                                    <IonSpinner style={{
                                        width: "40px",
                                        height: "40px",
                                        color: "#ff8a53"
                                    }} name="lines" />
                                </div>
                            </div>
                        )}
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={tabledata}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/*.....................View Project .................. */}
                <Modal
                    // id="logouts-modal"
                    dialogClassName="my-modal modal-dialog-centered"
                    show={modalopen}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">View Project</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Project Name </label>
                                        <div>
                                            <IonInput value={pname} disabled={isEdit === true ? false : true} onIonChange={(e: any) => setPname(e.detail.value)} className="form-control datetimepicker" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}>Plan Start</label>
                                                <div>
                                                    <IonInput style={{ height: "50%" }} value={fDate} disabled={isEdit === true ? false : true} onIonChange={(e: any) => setFDate(e.detail.value)} className="form-control datetimepicker" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}>Plan End</label>
                                                <div>
                                                    <IonInput style={{ height: "50%" }} value={tDate} disabled={isEdit === true ? false : true} onIonChange={(e: any) => setTDate(e.detail.value)} className="form-control datetimepicker" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Project Manager</label>
                                        <div>
                                            <IonInput style={{ height: "50%" }} value={projectManager} disabled={isEdit === true ? false : true} onIonChange={(e: any) => setProjectManager(e.detail.value)} className="form-control datetimepicker" />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Assigned Resources</label>
                                        <textarea
                                            rows={7}
                                            style={{ height: '150px' }}
                                            className="form-control datetimepicker"
                                            readOnly={isEdit === true ? false : true}
                                            value={assignedResources.join('\n')} // Join the assigned resources as lines
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Project Status</label>
                                        <div>
                                            <IonInput disabled={isEdit === true ? false : true} value={prjstatus} onIonChange={(e: any) => setprjstatus(e.detail.value)} className="form-control datetimepicker" ></IonInput>
                                        </div>
                                    </div>
                                </div>
                                {/* {loading && (
                                     <div className="modal-spinner">
                                     <div className="spinner-container">
                                         <IonSpinner
                                             style={{
                                                 width: "40px",
                                                 height: "40px",
                                                 color: "#ff8a53"
                                             }}
                                             name="lines"
                                         />
                                     </div>
                                 </div>
                                )} */}
                                {/* -----------col 2--------------- */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Project Description</label>
                                        <div>
                                            <textarea rows={5} style={{ height: "50%" }} value={projectDescription} disabled={isEdit === true ? false : true} onClick={(e: any) => setProjectDescription(e.detail.value)} className="form-control datetimepicker" />
                                        </div>
                                    </div>


                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Effort Booked</label>
                                        <DataTable
                                            columns={ViewProject}
                                            data={datas}
                                            pagination
                                            paginationPerPage={3}
                                            paginationComponentOptions={paginationComponentOptions}
                                            paginationRowsPerPageOptions={[10, 20, 30]}
                                            customStyles={customStyles}
                                        />
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label style={{ fontWeight: "bold" }}>YTD Effort </label>
                                                    <div>
                                                        <IonInput style={{ height: "50%" }} value={TillDate} disabled={isEdit === true ? false : true} onIonChange={(e: any) => settilldate(e.detail.value)} className="form-control datetimepicker" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label style={{ fontWeight: "bold" }}>Effort Current Month</label>
                                                    <div>
                                                        <IonInput style={{ height: "50%" }} value={TillMonth} disabled={isEdit === true ? false : true} onIonChange={(e: any) => settillmonth(e.detail.value)} className="form-control datetimepicker" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </form>
                    </div>

                </Modal>


            </IonContent>
        </IonPage>
    )
}

export default HRProjectDashboard
